import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

const getSkills = () => {
  const url = `${WORKFLOW_ENGINE_API}/skill`;
  return backend.get(url);
};

const getSkill = (skillRn) => {
  const url = `${WORKFLOW_ENGINE_API}/skill/${skillRn}`;
  return backend.get(url);
};

const createSkill = (body) => {
  const url = `${WORKFLOW_ENGINE_API}/skill`;
  return backend.post(url, body);
};

const deleteSkill = (skillRn) => {
  const url = `${WORKFLOW_ENGINE_API}/skill/${skillRn}`;
  return backend.delete(url);
};

const executeSkill = (skillRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/skill/${skillRn}/execute`;
  return backend.post(url, body);
};

const updateSkill = (skillRn, body) => {
  const url = `${WORKFLOW_ENGINE_API}/skill/${skillRn}`;
  return backend.put(url, body);
};

const testSkill = (body) => {
  const url = `${WORKFLOW_ENGINE_API}/skill/test`;
  return backend.post(url, body);
};

export default {
  getSkills,
  getSkill,
  createSkill,
  deleteSkill,
  executeSkill,
  updateSkill,
  testSkill,
};
